import { getConfig } from "@jti/fe-common";
import type { TssApiContract } from "@jti/rest-api-types";

import { getIsEvo, getUser } from "../../utils";

import { TssApiEvo } from "./TssApiEvo";
import { TssApiLegacy } from "./TssApiLegacy";

export class TssApi {
  readonly name = "TssApi";

  static init(): TssApiContract {
    const config = getConfig();
    const user = getUser();

    if (config.USE_EVO_ONLY) {
      return new TssApiEvo(config.EVO_DOMAIN, config.EVO_TENANT, user.ciam_token, config["X-RECAPTCHA-ID"]);
    }

    if (getIsEvo(config.TSS_URL)) {
      return new TssApiEvo(config.TSS_URL, config.TSS_TOKEN, user.ciam_token, config["X-RECAPTCHA-ID"]);
    }
    return new TssApiLegacy(config.TSS_URL, config.TSS_TOKEN, user.ciam_token);
  }
}
